import React, { useContext, useEffect, useState } from "react";
import i18n from "i18next";
import { initReactI18next, I18nextProvider } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import DataContext from "./context/DataContext";

import enDynamicDefault from "./assets/enDynamicDefault.json";

const I18nProvider = ({ children }) => {
    const { handleError, setIslocalizationsAvailable, localizations } =
        useContext(DataContext);

    const [isLoading, setIsLoading] = useState(true);
    const [currentLocalizations, setCurrentLocalizations] = useState(null);

    useEffect(() => {
        setCurrentLocalizations(localizations);
    }, [localizations]);

    const jsonConversion = (string) => {
        if (string) {
            return JSON.parse(
                string
                    .trim()
                    .replace(/(\r\n|\n|\r)/gm, "")
                    .replace(/\s+"/g, '"'),
            );
        }
    };

    const formatResources = (array) => {
        const reformatted = {};

        let defaultDynamic = null;
        if (!array || array.length === 0) {
            return {};
        }

        array.map((obj) => {
            const languageCode = obj["culture"] && obj["culture"].split("-")[0];
            if (languageCode === "en")
                defaultDynamic = obj.dynamicContent
                    ? JSON.parse(obj.dynamicContent)
                    : enDynamicDefault;
            const dynamic = obj.dynamicContent
                ? JSON.parse(obj.dynamicContent)
                : defaultDynamic
                  ? defaultDynamic
                  : enDynamicDefault;

            const translation = {
                ...jsonConversion(obj.staticContent),
                ...dynamic,
            };
            reformatted[languageCode] = { translation };
        });

        return reformatted;
    };

    const initiateI18n = (translationObj) => {
        const supportedLngs = Object.keys(translationObj);
        const fallbackLanguage =
            supportedLngs.length > 1 ? "en" : supportedLngs[0];

        if (i18n.isInitialized) {
            supportedLngs.forEach((lng) => {
                i18n.addResourceBundle(
                    lng,
                    "translation",
                    translationObj[lng].translation,
                    true,
                    true,
                );
            });
            const storedLng = localStorage.getItem("i18nextLng");
            const browserLng = navigator.language?.split("-")[0];
            const targetLng =
                [storedLng, browserLng].find((lng) =>
                    supportedLngs.includes(lng),
                ) || "en";
            i18n.changeLanguage(targetLng);
            setIslocalizationsAvailable(true);
            return;
        }

        i18n.use(LanguageDetector)
            .use(initReactI18next)
            .init(
                {
                    resources: translationObj,
                    fallbackLng: "en",
                    load: "languageOnly",
                    ...(supportedLngs.length > 0 && { supportedLngs }),

                    detection: {
                        order: ["localStorage", "navigator"],
                        caches: ["localStorage"],
                    },

                    interpolation: {
                        escapeValue: false,
                    },
                    react: {
                        useSuspense: false,
                    },
                },
                (err, t) => {
                    if (err) {
                        console.error("i18n initialization error:", err);
                        handleError(err);
                    } else {
                        setIslocalizationsAvailable(true);
                        setIsLoading(false);
                    }
                },
            );
    };

    useEffect(() => {
        currentLocalizations &&
            initiateI18n(formatResources(currentLocalizations));
    }, [currentLocalizations]);

    if (isLoading) {
        return;
    }

    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

export default I18nProvider;
